import { useState } from 'react';
import SignUpModal from '../modals/SignUpModal';

export default function WebinarSignUpButton() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <button
                onClick={() => setIsModalOpen(true)}
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-primary bg-white hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors"
            >
                Register for Webinar
            </button>

            <SignUpModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                formType="webinar"
            />
        </>
    );
} 